import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import nbqEcharts from "./nbqEcharts";
export default {
  name: "pvData",
  data: function data() {
    return {
      footerData: [{
        name: "PV1",
        voltage: "12V",
        current: "12A",
        power: "12W",
        temperature: "12℃"
      }, {
        name: "PV2",
        voltage: "12V",
        current: "12A",
        power: "12W",
        temperature: "12℃"
      }, {
        name: "PV3",
        voltage: "12V",
        current: "12A",
        power: "12W",
        temperature: "12℃"
      }, {
        name: "PV3",
        voltage: "12V",
        current: "12A",
        power: "12W",
        temperature: "12℃"
      }, {
        name: "PV3",
        voltage: "12V",
        current: "12A",
        power: "12W",
        temperature: "12℃"
      }, {
        name: "PV3",
        voltage: "12V",
        current: "12A",
        power: "12W",
        temperature: "12℃"
      }, {
        name: "PV3",
        voltage: "12V",
        current: "12A",
        power: "12W",
        temperature: "12℃"
      }]
    };
  },
  components: {
    nbqEcharts: nbqEcharts
  },
  methods: {}
};